var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0459 40 40 31.0459 40 20C40 8.95413 31.0459 0 20 0C8.95413 0 0 8.95413 0 20C0 31.0459 8.95413 40 20 40ZM20 38.2229C30.0645 38.2229 38.2229 30.0645 38.2229 20C38.2229 9.93547 30.0645 1.77707 20 1.77707C9.93547 1.77707 1.77707 9.93547 1.77707 20C1.77707 30.0645 9.93547 38.2229 20 38.2229ZM21.256 20.0917L26.2544 15.0939C26.6043 14.744 26.6021 14.1835 26.2544 13.8352C25.9061 13.4853 25.3456 13.4896 24.9979 13.8352L20 18.8331L15.0021 13.8352C14.6523 13.4853 14.0917 13.4875 13.7456 13.8352C13.3957 14.1856 13.3979 14.7456 13.7456 15.0939L18.744 20.0917L13.7456 25.0875C13.3957 25.4373 13.3979 25.9979 13.7456 26.3456C14.0939 26.696 14.6544 26.6939 15.0021 26.3456L20 21.3477L24.9979 26.3456C25.3477 26.696 25.9083 26.6939 26.2544 26.3456C26.6043 25.9957 26.6021 25.4352 26.2544 25.0875L21.256 20.0917Z",
    fill: "#5D5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.9ed1bd2d1818cc68c0c1590f4758b984.svg";
export { ForwardRef as ReactComponent };